/**
 * Explaining words
 *
 *
 * @module kickstarter/ExplainingWords
 */

"use strict";

class ExplainingWords {
    constructor(element, options) {
        this._element = element;
        this._options = options;
        this._initialize();
    }

    _initialize() {
        //explainingwords
        for (
            var i = 0;
            i < this._element.getElementsByClassName("explainB").length;
            i++
        ) {
            this._element
                .getElementsByClassName("explainB")
                [i].addEventListener("click", this.toggleExplainB, false);
        }
        this.explainingWords();
    }

    //sitewide explaining words
    explainingWords() {
        if (typeof explainingWordJSON !== "undefined") {
            //lowercase and parse
            var explainingWordJSONLC = explainingWordJSON.replace(
                /"([^"]+)":/g,
                function($0, $1) {
                    return '"' + $1.toLowerCase() + '":';
                }
            );
            var explanations = JSON.parse(explainingWordJSONLC)
                .explainingwordjson;
        } else var explanations = {};

        for (
            var i = 0;
            i < this._element.getElementsByClassName("explainB").length;
            i++
        ) {
            for (var j = 0; j < explanations.length; j++) {
                if (
                    explanations[j][
                        this._element
                            .getElementsByClassName("explainB")
                            [i].innerHTML.toLowerCase()
                    ]
                ) {
                    var explanation =
                        explanations[j][
                            this._element.getElementsByClassName("explainB")[i]
                                .innerHTML
                        ];

                    var explainNode = document.createElement("span");
                    explainNode.setAttribute("class", "explainContent");
                    explainNode.innerHTML = explanation;
                    this._element
                        .getElementsByClassName("explainB")
                        [i].appendChild(explainNode);
                    this._element
                        .getElementsByClassName("explainB")
                        [i].removeAttribute("href");
                    break;
                }
            }
        }

        //tooltipalike
        for (
            var i = 0;
            i < this._element.getElementsByClassName("explain").length;
            i++
        ) {
            for (var j = 0; j < explanations.length; j++) {
                if (
                    explanations[j][
                        this._element
                            .getElementsByClassName("explain")
                            [i].innerHTML.toLowerCase()
                    ]
                ) {
                    this._element
                        .getElementsByClassName("explain")
                        [i].setAttribute(
                            "data-tooltip",
                            explanations[j][
                                this._element
                                    .getElementsByClassName("explain")
                                    [i].innerHTML.toLowerCase()
                            ].replace(new RegExp("<br/>", "g"), "\n")
                        );
                    this._element
                        .getElementsByClassName("explain")
                        [i].removeAttribute("href");
                }
            }
            this._element
                .getElementsByClassName("explain")
                [i].setAttribute("data-tooltip-position", "bottom");
        }
    }

    toggleExplainB() {
        var el = this;
        if (el.lastChild.style.display == "block") {
            el.lastChild.removeAttribute("style");
            el.setAttribute("class", "explainB");
        } else {
            el.lastChild.style.display = "block";
            el.setAttribute("class", "explainB collapsed");
        }
    }
}

export default ExplainingWords;
